<template>
  <div class="cargo-box">
    <div class="cargo-bottom">
      <div class="cargo-bottom-box">
        <div class="bottom-box-name">物品</div>
        <div class="bottom-box-value">
          {{ detail?.cargo?.cargoName || "-" }}
        </div>
      </div>
      <div class="cargo-bottom-box">
        <div class="bottom-box-name">重量</div>
        <div class="bottom-box-value">
          {{ detail?.cargo?.weight || "-" }}
          {{ detail?.cargo?.wightUnit === 1 ? "吨" : "公斤" }}
        </div>
      </div>
      <div class="cargo-bottom-box">
        <div class="bottom-box-name">体积</div>
        <div class="bottom-box-value">{{ detail?.cargo?.volume || "-" }}㎡</div>
      </div>
      <div class="cargo-bottom-box">
        <div class="bottom-box-name">包装方式</div>
        <div class="bottom-box-value">
          {{ detail?.cargo?.packingWays || "-" }}
        </div>
      </div>
      <div class="cargo-bottom-box">
        <div class="bottom-box-name">发票</div>
        <div class="bottom-box-value">
          {{ detail.needInvoice ? "需要" : "不需要" }}
        </div>
      </div>
      <div class="cargo-bottom-box">
        <div class="bottom-box-name">回单</div>
        <div class="bottom-box-value">
          {{ getLocalLabel("receiptType", detail.receiptType) }}
        </div>
      </div>
<!--      <div class="cargo-bottom-box">-->
<!--        <div class="bottom-box-name">用车要求</div>-->
<!--        <div class="bottom-box-value">-->
<!--          {{ detail?.vehicleUseType || "-" }}-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="cargo-bottom-box">-->
<!--        <div class="bottom-box-name">车型</div>-->
<!--        <div class="bottom-box-value">-->
<!--          <custom-tooltip-multiple :text="detail?.vehicle?.vehicleMode"></custom-tooltip-multiple>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="cargo-bottom-box">-->
<!--        <div class="bottom-box-name">车长</div>-->
<!--        <div class="bottom-box-value">-->
<!--          <custom-tooltip-multiple :text="detail?.vehicle?.vehicleLength"></custom-tooltip-multiple>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="cargo-bottom" v-if="detail.remark">
<!--      <div class="cargo-bottom-box">-->
<!--        <div class="bottom-box-name">公里数</div>-->
<!--        <div class="bottom-box-value">{{ detail.kilometre || "-" }}km</div>-->
<!--      </div>-->

<!--      <div class="cargo-bottom-box">-->
<!--        <div class="bottom-box-name">技术服务费</div>-->
<!--        <div class="bottom-box-value" v-if="detail.orderSource === 1">{{ detail.technicalFee || "-" }}元</div>-->
<!--        <div class="bottom-box-value" v-if="detail.orderSource === 2">-->
<!--          {{ detail.technicalFee + detail.platformCommission }}元-->
<!--        </div>-->
<!--      </div>-->
      <div class="cargo-bottom-box cargo-bottom-box3" >
        <div class="bottom-box-name">备注</div>
        <div class="bottom-box-value" style="text-align: left">
          <custom-tooltip :text="detail.remark"></custom-tooltip>
        </div>
      </div>
    </div>
    <div class="cargo-bottom-img" v-if="detail?.cargo?.pictures && detail?.cargo?.pictures.length">
      <div class="cargo-bottom">
        <div class="cargo-bottom-box" v-for="(item, index) in detail?.cargo?.pictures" :key="index">
          <el-image :src="getFileUrl(item)" class="cargo-image" :preview-src-list="[getFileUrl(item)]"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomTooltip from "@/components/CustomTooltip.vue";
import CustomTooltipMultiple from "@/components/CustomTooltipMultiple.vue";
import { getFileUrl } from "@/utils/tool";
import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "CargoTemplate",
  components: { CustomTooltipMultiple, CustomTooltip },
  props: {
    detail: {
      type: Object,
      default: () =>{
        return {}
      }
    }
  },
  data() {
    return {
      getFileUrl
    }
  },
  methods: {
    getLocalLabel
  }
}
</script>

<style scoped lang="scss">
.cargo-box {
  background: #f7fbff;
  border-radius: 0.08rem;
  padding: 0.1rem;
  box-sizing: border-box;
  margin-top: 0.1rem;
  .cargo-bottom {
    width: 100%;
    display: flex;
    padding: 0.08rem 0;
    box-sizing: border-box;
    .cargo-bottom-box {
      width: 20%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      box-sizing: border-box;
      .cargo-image {
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 0.05rem;
      }
      .bottom-box-name {
        color: #8c8c8c;
        font-size: 0.12rem;
        margin-bottom: 0.06rem;
      }
      .bottom-box-value {
        color: #434343;
        font-size: 0.14rem;
        text-align: center;
      }
    }
    .cargo-bottom-box3 {
      width: 100%;
      align-items: flex-start;
      padding-left: 7%;
      box-sizing: border-box;
    }
    .cargo-bottom-box::before {
      content: "";
      position: absolute;
      right: 0;
      top: 0.06rem;
      width: 0.01rem;
      height: 0.26rem;
      background-color: #dce5f5;
    }
    .cargo-bottom-box:nth-last-of-type(1)::before {
      display: none;
    }
  }
}
</style>
